import { getLocalStorage, getCookie } from "../../../utils";
import BeEndpoints from "../../endpoints";

const loginApi = (makeRequest, signUpUserData) => {
  const request = {
    path: `${BeEndpoints.LOGIN}`,
    method: "POST",
    data: signUpUserData,
  };
  return makeRequest(request);
};

const spotifyCodeApi = (makeRequest, data) => {
  const request = {
    path: `${BeEndpoints.SPOTIFY_CODE + "/" + getLocalStorage("venue")}`,
    method: "PUT",
    data: data,
    headers: {
      AUTHORIZATION: "Token " + getCookie("user_key"),
    },
  };
  return makeRequest(request);
};


const profileDetailsApi = (makeRequest) => {
  const request = {
    path: `${BeEndpoints.PROFILE_DETAILS + "/" + getLocalStorage("venue")}`,
    method: "GET",
    headers: {
      AUTHORIZATION: "Token " + getCookie("user_key"),
    },
  };
  return makeRequest(request);
};

const updateHostApi = (makeRequest, data) => {
  const request = {
    path: `${BeEndpoints.PROFILE_DETAILS + "/" + getLocalStorage("venue")}`,
    method: "PUT",
    data: data,
    headers: {
      AUTHORIZATION: "Token " + getCookie("user_key"),
    },
  };
  return makeRequest(request);
};

const logoutApi = (makeRequest, logoutData) => {
  const request = {
    path: `${BeEndpoints.LOGOUT}`,
    method: "POST",
    data: logoutData,
    headers: {
      AUTHORIZATION: "Token " + getCookie("user_key"),
    },
  };
  return makeRequest(request);
};

export { loginApi, profileDetailsApi, logoutApi, updateHostApi, spotifyCodeApi };
